export const isValidCpf = (strCpf) => {
  strCpf = strCpf.replace(/\D/g, '')
  if (
    strCpf.length !== 11 ||
    strCpf === '00000000000' ||
    strCpf === '11111111111' ||
    strCpf === '22222222222' ||
    strCpf === '33333333333' ||
    strCpf === '44444444444' ||
    strCpf === '55555555555' ||
    strCpf === '66666666666' ||
    strCpf === '77777777777' ||
    strCpf === '88888888888' ||
    strCpf === '99999999999'
  ) {
    return false
  }

  let sum = 0
  let rest
  for (let i = 1; i <= 9; i += 1) {
    sum += parseInt(strCpf.substring(i - 1, i), 10) * (11 - i)
  }

  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) {
    rest = 0
  }

  if (rest !== parseInt(strCpf.slice(9, 10), 10)) {
    return false
  }

  sum = 0
  for (let i = 1; i <= 10; i += 1) {
    sum += parseInt(strCpf.substring(i - 1, i), 10) * (12 - i)
  }

  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) {
    rest = 0
  }

  if (rest !== parseInt(strCpf.slice(10, 11), 10)) {
    return false
  }

  return true
}

function charToValue(char) {
  return char.charCodeAt(0) - 48
}

function calculateDigit(base, weights = []) {
  const sum = base.split('').reduce((acc, char, index) => {
    return acc + charToValue(char) * weights[index]
  }, 0)

  const remainder = sum % 11

  return remainder < 2 ? 0 : 11 - remainder
}

export function isValidCnpj(value) {
  if (!value) {
    return false
  }

  const cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, '')

  // Deve possuir 14 caracteres
  if (cleaned.length !== 14) {
    return false
  }

  // Evita valores repetidos tipo 00000000000000
  if (/^([A-Z0-9])\1+$/.test(cleaned)) {
    return false
  }

  const base = cleaned.slice(0, 12)
  const dv = cleaned.slice(12)

  // Calcula primeiro dígito
  const digit1 = calculateDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])

  // Calcula segundo dígito
  const digit2 = calculateDigit(base + digit1, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])

  // Compara com os dígitos informados
  return dv === `${digit1}${digit2}`
}
